import { LOAD_ACE_ALERTS, } from "./action";

const initialState = {
	currentAceAlert: [],
	currentPage: 0,
	totalAceAlerts: 0,
	totalPages: 0,
	sortValue: '',
	sortOrder: ''
};

const reducer = (state = initialState, action) => {
	switch (action.type) {

		case LOAD_ACE_ALERTS:
			return {
				...state, 
				currentAceAlert: action.aceAlert, 
				currentPage: action.currentPage, 
				totalAceAlerts: action.totalAceAlerts,
				totalPages: action.totalPages,
				sortValue: action.sortValue,
				sortOrder: action.sortOrder
			};
		default:
			return state;
	}
};

export default reducer;


// WEBPACK FOOTER //
// ./src/components/Admin/storeAceAlerts/reducer.js